import { Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    mainContainer: {
      backgroundColor: theme.colors.secondary,
      overflow: "hidden",
      flex: 1,
    },
    choosePolicyText: {
      maxWidth: 600,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      alignItems: "center",
      "@media (min-width: 200px)": {
        // iPhone 7, 8
        paddingLeft: theme.spacing.md,
        display: "flex",
      },
      "@media (min-width: 385px)": {
        // iPhone 11, 12
        paddingLeft: theme.spacing.md,
      },
      "@media (min-width: 700px)": {
        // for ipad
        paddingLeft: 0,
        display: "none",
      },
    },
    heading: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.bold,
      marginTop: 0,
      display: "flex",
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.lg,
      },
      "@media (min-width: 385px)": {
        fontSize: theme.fontsize.xlg,
      },
      "@media (min-width: 700px)": {
        fontSize: theme.fontsize.xlg,
      },
    },
    containerFluid: {
      display: "flex",
      flex: 1,
      minHeight: 300,
    },
    scrollContainer: {
      flex: 1,
      height: "100%",
      backgroundColor: "transparent",
    },
    scrollArea: {
      display: "flex",
      flex: 1,
      "@media (min-width: 700px)": {
        paddingHorizontal: 46,
      },
    },
    container: {
      marginTop: theme.margin.md,
      marginLeft: theme.margin.lg,
      marginRight: theme.margin.md,
      "@media (min-width: 1000px)": {
        maxWidth: 1180,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      },
      backgroundColor: "transparent",
      elevation: 16,
    },
    contactAgentList: {
      marginTop: theme.margin.reg,
    },
    graphicArea: {
      position: "relative",
      top: 150,
      left: 0,
    },
    agentImage: {
      width: 400,
      height: 600,
      marginTop: 140,
    },
    yourAgenInfo: {
      // width: "40%",
      display: "none",
      marginRight: theme.margin.md,
      "@media (min-width: 700px)": {
        ...Platform.select({
          ios: {
            display: "flex",
          },
          android: {
            display: "flex",
          },
        }),
      },
    },
    contactInfo: {
      width: "100%",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            top: 10,
          },
          "@media (min-width: 700px)": {
            // for low resolution iPad
            width: "40%",
            position: "absolute",
            top: 20,
            right: 0,
          },
          "@media (min-width: 1050px)": {
            // for hight resolution iPad
            width: "40%",
            position: "relative",
          },
        },
        android: {
          "@media (min-width: 700px)": {
            // for low resolution iPad
            width: "40%",
            position: "absolute",
            top: 20,
            right: 0,
          },
          "@media (min-width: 1050px)": {
            // for hight resolution iPad
            width: "40%",
            position: "relative",
          },
        },
      }),
    },
    contactAgent: {
      width: 600,
      height: 650,
      position: "absolute",
      left: 0,
      top: -236,
      ...Platform.select({
        ios: {
          "@media (min-width: 700px)": {
            width: 500,
            height: 525,
          },
          "@media (min-width: 1100px)": {
            width: 600,
            height: 625,
          },
        },
        android: {
          "@media (min-width: 700px)": {
            left: -60,
            width: 500,
            height: 525,
          },
          "@media (min-width: 1100px)": {
            width: 600,
            height: 625,
          },
        },
      }),
    },
    headingText: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontSize: theme.fontsize.xxl2,
      maxHeight: 60,
      position: "relative",
      top: 16,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    bodyText: {
      width: 400,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.cs,
      position: "relative",
      top: 28,
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    contactIcon: {
      width: 34,
      height: 55,
    },
    contactIconFaded: {
      height: 98,
      width: 58,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    inboxIcon: {
      width: 50.7,
      height: 35.9,
    },
    inboxIconFaded: {
      height: 65,
      width: 93,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    callIcon: {
      width: 49,
      height: 73.7,
    },
    callIconFaded: {
      height: 116,
      width: 76,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    emailIcon: {
      width: 49,
      height: 70,
    },
    emailIconFaded: {
      height: 121,
      width: 98,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    faxIcon: {
      width: 48.7,
      height: 42.8,
    },
    faxIconFaded: {
      height: 83,
      width: 98,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    claimDetail: {
      zIndex: -1,
      justifyContent: "space-between",
    },
    marginLeft: {
      marginLeft: 12,
    },
    contactAgentCard: {
      minHeight: 90,
      height: "auto",
      width: "100%",
      borderRadius: 13,

      borderStyle: "solid",
      borderWidth: 2,
      borderColor: theme.colors.white,
      padding: 10,
      marginBottom: 16,
      overflow: "hidden",
      backgroundColor: theme.colors.white + 20,
    },
    contactAgentCardFaded: {
      minHeight: 90,
      height: "auto",
      borderRadius: 13,

      padding: 10,
      marginBottom: 16,
      overflow: "hidden",
      backgroundColor: theme.colors.white + 20,
    },
    title: {
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: 20,
    },
    address: {
      color: theme.colors.white,
      marginTop: 6,
      fontSize: 16,
    },
    arrowDown: {
      position: "absolute",
      right: 15,
      top: 22,
      width: 16,
      height: 16,
    },
    WhiteText: {
      color: theme.colors.white,
      fontWeight: "600",
      paddingLeft: 24,
    },
  },
  web: {
    mainContainer: {
      backgroundColor: theme.colors.secondary,
      overflow: "hidden",
      flex: 1,
    },
    choosePolicyText: {
      maxWidth: 600,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      alignItems: "center",
      display: "flex",
    },
    heading: {
      display: "none",
    },
    containerFluid: {},
    scrollContainer: {
      flex: 1,
      height: "100%",
      backgroundColor: "transparent",
    },
    scrollArea: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: "100%",
    },
    container: {
      marginTop: theme.margin.reg,
      marginLeft: theme.margin.lg,
      marginRight: theme.margin.md,
      "@media (min-width: 700px)": {},
      "@media (min-width: 1000px)": {
        maxWidth: 1180,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      },
      backgroundColor: "transparent",
      elevation: 16,
    },
    contactAgentList: {
      marginTop: theme.margin.reg,
    },
    graphicArea: {
      position: "relative",
      top: 120,
    },
    agentImage: {
      width: 400,
      height: 400,
      marginTop: 180,
    },
    yourAgenInfo: {
      width: "35%",
      display: "none",
      marginRight: theme.margin.md,
      "@media (min-width: 700px)": {
        ...Platform.select({
          ios: {
            display: "flex",
          },
          android: {
            display: "flex",
          },
          web: {
            display: "block",
          },
        }),
      },
    },
    contactInfo: {
      width: "100%",
      "@media (min-width: 200px)": {
        width: "100%",
      },
      "@media (min-width: 700px)": {
        width: "40%",
        position: "absolute",
        right: 0,
      },
    },
    contactAgent: {
      width: 560,
      height: 610,
      position: "absolute",
      left: 40,
      top: -236,
      "@media (min-width: 335px)": {
        transform: [{ scale: ".6" }],
        top: -236,
      },
      "@media (min-width: 700px)": {
        transform: [{ scale: ".7" }],
        top: -236,
      },
      "@media (min-width: 1150px)": {
        transform: [{ scale: ".9" }],
        top: -166,
      },
      "@media (min-width: 1281px)": {
        transform: [{ scale: "1" }],
        top: -136,
      },
      "@media (min-width: 1441px)": {
        transform: [{ scale: "1" }],
        top: -136,
      },
      "@media (min-width: 1681px)": {
        transform: [{ scale: "1" }],
        top: -136,
      },
    },
    headingText: {
      lineHeight: theme.fontsize.lg,
      fontSize: theme.fontsize.xxl2,
      position: "relative",
      // top: theme.margin.reg,
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,

      textTransform: "uppercase",
    },
    bodyText: {
      width: 400,
      fontSize: theme.fontsize.cs,
      fontFamily: theme.fontFamily.robotoRegular,
      fontWeight: theme.fontweight.light,
      position: "relative",

      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    contactIcon: {
      width: 34,
      height: 55,
    },
    contactIconFaded: {
      height: 98,
      width: 58,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    inboxIcon: {
      width: 50.7,
      height: 35.9,
    },
    inboxIconFaded: {
      height: 65,
      width: 93,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    callIcon: {
      width: 49,
      height: 73.7,
    },
    callIconFaded: {
      height: 116,
      width: 76,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    emailIcon: {
      width: 49,
      height: 70,
    },
    emailIconFaded: {
      height: 121,
      width: 98,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    faxIcon: {
      width: 48.7,
      height: 42.8,
    },
    faxIconFaded: {
      height: 83,
      width: 98,
      transform: [{ rotate: "-15deg" }],
      opacity: 0.1,
      position: "absolute",
      right: 0,
    },
    claimDetail: {
      zIndex: -1,
      marginTop: 8,
    },
    marginLeft: {
      marginLeft: theme.margin.reg,
    },
    contactAgentCard: {
      minHeight: 90,
      height: "auto",
      width: "100%",
      borderRadius: theme.radius.reg,

      borderStyle: "solid",
      borderWidth: 2,
      borderColor: theme.colors.white,
      padding: theme.spacing.reg,
      marginBottom: theme.margin.md,
      overflow: "hidden",
      backgroundColor: theme.colors.white + 20,
    },
    contactAgentCardFaded: {
      minHeight: 90,
      height: "auto",
      borderRadius: theme.radius.reg,

      padding: theme.spacing.reg,
      marginBottom: theme.margin.md,
      overflow: "hidden",
      backgroundColor: theme.colors.white + 20,
    },
    title: {
      fontFamily: theme.fontFamily.robotoRegular,
      fontWeight: theme.fontweight.bold,
      color: theme.colors.white,
      fontSize: theme.fontsize.mmd,
    },
    address: {
      color: theme.colors.white,
      marginTop: 6,
      fontSize: 16,
    },
    arrowDown: {
      position: "absolute",
      right: 15,
      top: 22,
      width: 16,
      height: 16,
    },
    WhiteText: {
      color: theme.colors.white,
      fontWeight: "600",
      paddingLeft: 24,
    },
  },
});
